/**
 * Plugin Scripts Entrypoint.
 *
 * This file serves as a place to import all of the JS that will eventually be bundled by Webpack to form the production-ready version.
 *
 * @author Nick Patterson <nick@fifteen4.com>
 */

/** Dependencies -------------------------------------------- */

// Internal

import dropdown from './includes/dropdown'
import { traverseEventName, default as traversal } from './includes/traversal'
import clickBehavior from './includes/clickBehavior'
import burgerhood from './includes/burgerhood'

/** Initialization ------------------------------------------ */

function onDomContentLoaded() {

	const plugin = window.cuSupernav
	
	plugin.getElement = () => document.getElementById( plugin.cssNamespace )

	if ( plugin.getElement() === null ) return

	dropdown.init( {
		namespace: plugin.cssNamespace
	} )

	traversal.init( {
		namespace          : plugin.cssNamespace,
		hamburgerBreakpoint: plugin.hamburgerBreakpoint
	} )

	const clickBehaviorSingleton = clickBehavior.init( {
		namespace          : plugin.cssNamespace,
		hamburgerBreakpoint: plugin.hamburgerBreakpoint
	} )

	plugin.addClickBehaviorHook = clickBehaviorSingleton.addHook
	plugin.openModal            = clickBehaviorSingleton.openModal
	plugin.copyTextToClipboard  = clickBehaviorSingleton.copyTextToClipboard

	const burgerhoodSingleton = burgerhood.init( {
		namespace          : plugin.cssNamespace,
		hamburgerBreakpoint: plugin.hamburgerBreakpoint
	} )

	plugin.getOpenState = () => burgerhoodSingleton.state.isOpen
	plugin.setOpenState = burgerhoodSingleton.setOpenState

}

function onPageShow() {

}

if ( document.readyState !== 'loading' ) {
    onDomContentLoaded()
}
else {
    window.addEventListener( 'DOMContentLoaded', onDomContentLoaded )
}

window.addEventListener( 'pageshow', onPageShow )
